export function routineFilename(name) {
  const safeName = [...(name || 'rutina')]
    .filter((character) => character.charCodeAt(0) >= 32 && !/[<>:"/\\|?*]/.test(character))
    .join('')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/^[.-]+|[.-]+$/g, '');
  const baseName = safeName || 'rutina';
  const reservedWindowsName = /^(con|prn|aux|nul|com[1-9]|lpt[1-9])(?:\..*)?$/i;
  return `${reservedWindowsName.test(baseName) ? `rutina-${baseName}` : baseName}.pdf`;
}

export function downloadRoutine(routine) {
  const { jsPDF } = require('jspdf');
  const doc = new jsPDF();
  const margin = 15;
  const lineHeight = 7;
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const maxWidth = pageWidth - margin * 2;
  let y = margin;

  const write = (content, options = {}) => {
    const lines = doc.splitTextToSize(content, maxWidth);
    const height = lines.length * lineHeight;
    if (y + height > pageHeight - margin) {
      doc.addPage();
      y = margin;
    }
    if (options.bold) doc.setFont('helvetica', 'bold');
    doc.text(lines, margin, y);
    if (options.bold) doc.setFont('helvetica', 'normal');
    y += height + (options.gapAfter || 0);
  };

  doc.setFont('helvetica', 'bold');
  write(routine.name || 'Rutina');
  doc.setFont('helvetica', 'normal');

  (routine.days || []).forEach((day, dayIndex) => {
    y += lineHeight;
    write(day.name || `Día ${dayIndex + 1}`, { bold: true, gapAfter: 1 });
    const items = Array.isArray(day.items) ? day.items : [];
    if (items.length === 0) {
      write('Sin ejercicios', { gapAfter: 1 });
    } else {
      items.forEach((item) => {
        const exerciseName = (item.exercise && item.exercise.name) || 'Ejercicio';
        const sets = item.sets || '—';
        const reps = item.reps || '—';
        let prescription = `${exerciseName}: ${sets} series × ${reps} repeticiones`;
        if (item.restSeconds !== null && item.restSeconds !== undefined && item.restSeconds !== '') {
          prescription += ` — Descanso: ${item.restSeconds} s`;
        }
        write(prescription);
        if (item.note && item.note.trim()) write(`Nota: ${item.note.trim()}`, { gapAfter: 1 });
      });
    }
  });

  doc.save(routineFilename(routine.name));
}
